// extracted by mini-css-extract-plugin
module.exports = {"embla__dot":"EmblaDotButtons_embla__dot__j_EGW","embla__dotActive":"EmblaDotButtons_embla__dotActive__o8_Kf","emblaDots":"EmblaDotButtons_emblaDots__7Odt_"};